module.exports = __webpack_public_path__ + "img/img_rg.d6333dc3.png";